module.exports = __webpack_public_path__ + "img/employees.e7b4b2fc.svg";